import React, { useState } from 'react';

const PdfUploader = ({ onFileChange }) => {
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    
    // Notifier le parent des fichiers sélectionnés
    if (onFileChange) {
      onFileChange(selectedFiles);
    }
  };

  return (
    <div>
      {/* <label htmlFor="fileUpload">Choisir des fichiers :</label><br /> */}
      <input
        id="fileUpload"
        type="file"
        multiple
        accept="application/pdf"
        onChange={handleFileChange}
      />
      
      {files.length > 0 && (
        <div style={{ marginTop: '10px' }}>
          <strong>Fichiers sélectionnés :</strong>
          <ul id='file-list'>
            {files.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PdfUploader;